import { useEffect, useState } from "react";
import { Flame, X, ArrowRight } from "lucide-react";

const STORAGE_KEY = "meno_promo_dismissed_v1";

export default function PromoBanner({ onDismiss }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleDismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(STORAGE_KEY, "1");
    onDismiss?.();
  };

  return (
    <a
      href="#book"
      data-testid="promo-banner"
      className={`fixed top-0 left-0 right-0 z-[60] bg-[#FF3B30] text-white border-b border-black/20 transition-transform duration-500 ${
        mounted ? "translate-y-0" : "-translate-y-full"
      }`}
      style={{ height: "40px" }}
    >
      <div className="relative h-full max-w-7xl mx-auto px-12 flex items-center justify-center text-center">
        <div className="flex items-center gap-3 text-[10px] sm:text-xs tracking-[0.18em] uppercase font-bold">
          <Flame size={14} className="shrink-0 hidden sm:block" />
          <span className="hidden md:inline">Limited spots —</span>
          <span>Claim your FREE first session</span>
          <ArrowRight size={14} className="shrink-0 hidden sm:block" />
        </div>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss promo"
          data-testid="promo-banner-dismiss"
          className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 p-1 opacity-70 hover:opacity-100"
        >
          <X size={14} />
        </button>
      </div>
    </a>
  );
}

export { STORAGE_KEY };
